import React from 'react';
import Alert from '../Alert';
import Paginate from '../Paginate';
import Results from '../Results';

export default ({itemCount, totalCount, query, pathname, limit, error, originalItemCount, className}) => (
	<div className='ListResults'>
		{
			itemCount !== false ? (
				<div className='ListResults_nav'>
					<div className='ListResults_paginate'>
						<Paginate query={query} pathname={pathname} limit={limit} page={query.page} itemCount={itemCount} originalItemCount={originalItemCount} totalCount={totalCount}/>
					</div>
					<Results limit={limit} page={query.page} itemCount={itemCount} totalCount={totalCount} classNameNoResults={className}/>
				</div>
			) : null
		}
		<div className='ListResults_info'>
			{
				error ? (
					<div>
						<Alert type='error'>{error}</Alert>
					</div>
				) : null
			}
		</div>
	</div>
);
